import { render, staticRenderFns } from "./FormSubmitButton.vue?vue&type=template&id=c014263e"
import script from "./FormSubmitButton.vue?vue&type=script&lang=ts"
export * from "./FormSubmitButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports